export const OVERVIEW_SEDIMENT_MOLD_PARAMETER_ID = '139275';
export const OVERVIEW_CONTACT_MOLD_PARAMETER_ID = '139263';

export const CONTACT_MOLD_NO_RESULT_VALUE = 'Kein Befund';

// Has value for mold sediment sum parameter and is one of the known sediment mold parameters
export function isSedimentMoldParameter(
  strPmId: string,
  allParams: Record<string, string>,
) {
  return (
    [
      '139265',
      '139266',
      '139267',
      '139268',
      '139269',
      '139270',
      '139271',
      '139272',
      '139273',
    ].includes(strPmId) &&
    allParams[OVERVIEW_SEDIMENT_MOLD_PARAMETER_ID] &&
    allParams[OVERVIEW_SEDIMENT_MOLD_PARAMETER_ID] !== ''
  );
}

// Check if the parameter is a contact mold parameter
export function isContactMoldParameter(
  strPmId: string,
  allParams: Record<string, string>,
) {
  return (
    [
      '139252',
      '139254',
      '139255',
      '139256',
      '139257',
      '139258',
      '139260',
      '139261',
      '139262',
    ].includes(strPmId) &&
    allParams[OVERVIEW_CONTACT_MOLD_PARAMETER_ID] &&
    allParams[OVERVIEW_CONTACT_MOLD_PARAMETER_ID] !== ''
  );
}
